var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 64,
    viewBox: "0 0 78 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.92 54.74L28.54 56.98C25.08 60.95 20.6 63.06 16 63.06C7.3 63.06 0 55.77 0 47C0 38.23 7.3 31 16 31C20.61 31 25.09 33.05 28.54 37.08L25.92 39.26C23.1 36 19.71 34.4 16 34.4C8.96 34.4 3.39 39.97 3.39 47.01C3.39 54.05 8.96 59.68 16 59.68C19.71 59.68 23.1 58.08 25.92 54.75V54.74Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6291 47.11V62.6H74.1691V47.11C74.1691 39.75 68.4091 33.99 61.0491 33.99C53.6891 33.99 47.9291 39.75 47.9291 47.11V62.6H44.5391V0H47.9291V36.8C49.5891 33.98 54.9691 30.59 61.0491 30.59C70.0691 30.59 77.6291 38.08 77.6291 47.1V47.11Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCh);
export default __webpack_public_path__ + "static/media/CH.88fefb92cecf4e55bc055d3d1ac2fceb.svg";
export { ForwardRef as ReactComponent };